import { render, staticRenderFns } from "./TcAddress.vue?vue&type=template&id=4ed1bc5a&scoped=true&"
import script from "./TcAddress.vue?vue&type=script&lang=ts&"
export * from "./TcAddress.vue?vue&type=script&lang=ts&"
import style0 from "./TcAddress.vue?vue&type=style&index=0&id=4ed1bc5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed1bc5a",
  null
  
)

export default component.exports